module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av706-6c0885e34dd477c44c8801855328499f.jpg";